import { Modal } from "antd"
import { ReactComponent as Check } from '../../assets/images/icon/check.svg'
import { ReactComponent as CircleCheckV2 } from '../../assets/images/icon/circleCheckV2.svg'
import { MarketingAgreement, PersonInfoPolicy, ServiceUseTerm } from "../../shared"
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../entities/context";
import { useState } from "react";
import { createOrUpdatePolicyDataTransferAgree } from "../../service";
import { ReactComponent as ArrowRight } from '../../assets/images/icon/arrow-right.svg'

interface IProps {
    setAgreememtList: Function
}

const PolicyDataTransferContainer = ({ setAgreememtList }: IProps) => {
    const [personInfoModalStatus, setPersonInfoModalStatus] = useState<boolean>(false);
    const [serviceUseTermModalStatus, setServiceUseTermModalStatus] = useState<boolean>(false);
    const [marketingAgreementModalStatus, setMarketingAgreementModalStatus] = useState<boolean>(false);
    const [agreememt0, setAgreememt0] = useState<boolean>(false);
    const [agreememt1, setAgreememt1] = useState<boolean>(false);
    const [agreememt2, setAgreememt2] = useState<boolean>(false);
    const { topHeight } = useMyContext();

    const handleAgreement = (idx?: number) => {
        let value = [agreememt0, agreememt1, agreememt2]
        if (idx !== undefined) {
            if (idx === 0) {
                value = [!agreememt0, agreememt1, agreememt2]
                setAgreememt0(!agreememt0)
            } else if (idx === 1) {
                value = [agreememt0, !agreememt1, agreememt2]
                setAgreememt1(!agreememt1)
            } else if (idx === 2) {
                value = [agreememt0, agreememt1, !agreememt2]
                setAgreememt2(!agreememt2)
            }
        } else {
            const isAllTrue = value.every((i) => i)
            if (isAllTrue) {
                value = [false, false, false]
                setAgreememt0(false)
                setAgreememt1(false)
                setAgreememt2(false)
            } else {
                value = [true, true, true]
                setAgreememt0(true)
                setAgreememt1(true)
                setAgreememt2(true)
            }
        }
        setAgreememtList(value)
    }

    return <>
        <div style={{ display: "flex", gap: "12px", padding: "10px 0px", }} onClick={() => handleAgreement()} >
            <CircleCheckV2 style={{ cursor: "pointer" }} fill={[agreememt0, agreememt1, agreememt2].every((i) => i) ? "#000000" : "#FFFFFF"} stroke={[agreememt0, agreememt1, agreememt2].every((i) => i) ? "#FFFFFF" : "#DDDDDD"} />
            <div className="sub-title/st3" >아래 약관에 모두 동의합니다</div>
        </div>
        <div style={{ marginBottom: '30px' }}>
            <div style={{ width: '100%', display: "flex", alignItems: "center", gap: "10px" }} onClick={() => handleAgreement(0)}>
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Check width={16} height={16} style={{ cursor: "pointer" }} stroke={agreememt0 ? "var(--baseblack)" : "var(--secondarys400)"} />
                    <div className="body/b1 secondary/s800" >[필수] 서비스 이용약관</div>
                </div>
                <ArrowRight width={16} height={16} stroke="var(--secondarys400)" onClick={(q) => { q.stopPropagation(); setServiceUseTermModalStatus(true) }} style={{ padding: '8px' }} />
            </div>
            <div style={{ width: '100%', display: "flex", alignItems: "center", gap: "10px" }} onClick={() => handleAgreement(1)}>
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Check width={16} height={16} style={{ cursor: "pointer" }} stroke={agreememt1 ? "var(--baseblack)" : "var(--secondarys400)"} />
                    <div className="body/b1 secondary/s800" >[필수] 개인정보 수집 및 이용 동의</div>
                </div>
                <ArrowRight width={16} height={16} stroke="var(--secondarys400)" onClick={(q) => { q.stopPropagation(); setPersonInfoModalStatus(true) }} style={{ padding: '8px' }} />
            </div>
            <div style={{ width: '100%', display: "flex", alignItems: "center", justifyContent: 'space-between' }} onClick={() => handleAgreement(2)}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Check width={16} height={16} style={{ cursor: "pointer" }} stroke={agreememt2 ? "var(--baseblack)" : "var(--secondarys400)"} />
                    <div className="body/b1 secondary/s800" >[선택] 마케팅 정보 수신 동의</div>
                </div>
                <ArrowRight width={16} height={16} stroke="var(--secondarys400)" onClick={(q) => { q.stopPropagation(); setMarketingAgreementModalStatus(true) }} style={{ padding: '8px' }} />
            </div>
        </div>


        <Modal style={{ top: Number(topHeight) + 16 }} open={personInfoModalStatus} onCancel={() => setPersonInfoModalStatus(false)} footer={false}>
            <PersonInfoPolicy isModal={true} />
        </Modal>
        <Modal style={{ top: Number(topHeight) + 16 }} open={serviceUseTermModalStatus} onCancel={() => setServiceUseTermModalStatus(false)} footer={false}>
            <ServiceUseTerm isModal={true} />
        </Modal>
        <Modal style={{ top: Number(topHeight) + 16 }} open={marketingAgreementModalStatus} onCancel={() => setMarketingAgreementModalStatus(false)} footer={false}>
            <MarketingAgreement isModal />
        </Modal>
    </>
}

export default PolicyDataTransferContainer